(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hiriwa-country-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{
  if(event.target.matches('[data-hw-country-select]'))event.target.form.requestSubmit();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hiriwa-international-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => {
    const notice = document.getElementById('hw-international-notice');
    if (!notice) return;
    const key = 'hiriwa-international-notice-v1';
    try { if (sessionStorage.getItem(key) === 'dismissed') return; } catch {}
    const dismiss = () => {
      notice.hidden = true;
      try { sessionStorage.setItem(key, 'dismissed'); } catch {}
    };
    notice.querySelectorAll('button').forEach(button => button.addEventListener('click', dismiss));
    notice.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
    notice.hidden = false;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hiriwa-policy-popup"] && !Shopify.designMode) return;
  try {
    const policyDialog=document.getElementById('hw-policy-popup');
if(policyDialog){
  const select=policyDialog.querySelector('select');
  const body=policyDialog.querySelector('.hw-policy-popup-body');
  const templates=[...policyDialog.querySelectorAll('template[data-hw-policy-path]')];
  const showPolicy=path=>{
    const template=templates.find(item=>item.dataset.hwPolicyPath===path);
    if(!template)return false;
    select.value=path;
    body.replaceChildren(template.content.cloneNode(true));
    body.scrollTop=0;
    return true;
  };
  select.addEventListener('change',()=>showPolicy(select.value));
  policyDialog.querySelector('[data-hw-policy-close]').addEventListener('click',()=>policyDialog.close());
  policyDialog.addEventListener('click',event=>{
    if(event.target!==policyDialog)return;
    const rect=policyDialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)policyDialog.close();
  });
  document.addEventListener('click',event=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!(event.target instanceof Element))return;
    const link=event.target.closest('a[href]');
    if(!link||link.hasAttribute('download')||typeof policyDialog.showModal!=='function')return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin||!showPolicy(url.pathname.replace(/\/$/,'')))return;
    event.preventDefault();
    if(!policyDialog.open)policyDialog.showModal();
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hiriwa-portrait-agreement"] && !Shopify.designMode) return;
  try {
    const updatePortraitSharing = (agreement) => {
  const choice = agreement.querySelector('[data-hw-share-choice]');
  const record = agreement.querySelector('[data-hw-share-record]');
  if (choice && record) record.value = choice.checked ? 'Yes, permission to share has been granted' : 'No, please keep private';
};
document.addEventListener('change', (event) => {
  if (event.target.matches('[data-hw-share-choice]')) updatePortraitSharing(event.target.closest('.hw-portrait-agreement'));
});
document.addEventListener('submit', (event) => {
  event.target.querySelectorAll('.hw-portrait-agreement').forEach(updatePortraitSharing);
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hiriwa-portrait-redirect"] && !Shopify.designMode) return;
  try {
    if(document.querySelector('[data-hw-portrait-redirect]')&&!window.Shopify?.designMode){window.location.replace('/pages/pet-portraits#tile-cover-pSSeGp');}
  } catch(e) { console.error(e); }
})();

})();
